import csvtojson from 'csvtojson';

export default function helpCsvParser(helpCsv) {
  return new Promise((resolve, reject) => {
    csvtojson()
      .fromString(helpCsv)
      .then(json => {
        const convertedHelp = convertHelpJson(json);
        resolve(convertedHelp);
      })
      .catch(err => {
        console.error(err);
        reject(err);
      });
  });
}

function convertHelpJson(json) {
  const convertedHelp = {};
  json.forEach(topic => {
    const [key, data] = convertHelpTopic(topic);
    convertedHelp[key] = data;
  });
  return convertedHelp;
}

function convertHelpTopic(topic) {
  const {Key, ...data} = topic;
  return [Key, data];
}
